(function(angular){
    'use strict';

    angular.module('nucleus.trial-widget').factory('trialService', trialService);
    trialService.$inject = ['$http', '$rootScope', '$q'];

    function trialService($http, $rootScope, $q) {
		var factory = {
			getTrialExpiration: getTrialExpiration,
			extendTrial: extendTrial,
			getPermissionGroups: getPermissionGroups,
			verifyUniqueStaffId: verifyUniqueStaffId,
			parseStaffName: parseStaffName,
			calculateDisplayAs: calculateDisplayAs,
			onSendClick: onSendClick
		};

		return factory;

		function getTrialExpiration() {
			return $http({
				method: 'GET',
				url: '/api/provisioning/v1/trials'
			});
		}
		function extendTrial(trialData) {
			return $http({
				method: 'PUT',
				url: '/api/provisioning/v1/trials/' + trialData.id,
				data: trialData
			});
		}
		function getPermissionGroups() {
			return $http({
				method: 'GET',
				url: '/api/profiles/v1/permissions/subject-groups'
			});
		}
		function getCompanyId() {
			return $http({
                method: 'GET',
                url: '/api/security/v1/session-bindings'
            }).then(function(res){
                return res.data.ApplicationConfiguration.CompanyId;
            });
		}
		function verifyUniqueStaffId(value) {
			return getCompanyId().then(function(companyId){
				return $http({
					method: 'GET',
					url: '/api/core/v3/companies/' + companyId + '/employees/verify-value-is-unique',
					params: {
						excludeId: 'new',
						value: value
					}
				}).then(function(res){
					console.log(JSON.stringify(res.data.value,null,2));
					return res.data.value;
				});
			});
		}
		function parseStaffName(staffName){
			return $http({
				method: 'GET',
				url: '/api/core/v1/contacts/parse-name',
				params: {
					fullName: staffName
				}
			}).then(function(resp) {
				var nameOutput = {};
				nameOutput.familyName = resp.data.familyName;
				nameOutput.fullName = resp.data.fullName;
				nameOutput.givenName = resp.data.givenName;
				return nameOutput;
			});
		}
		function calculateDisplayAs(familyName, fullName, givenName){
			return $http({
				method: 'POST',
				url: '/api/core/v1/contacts/calculate-display-as',
				data: {
					displayAs: 'unspecified',
					displayAsFormat: {name: 'Last, First', id: 'FAMILYGIVEN'},
					familyName: familyName,
					fullName: fullName,
					givenName: givenName
				}
			}).then(function(res){
				return res.data;
			});
		}
		function getDefaultContact(companyId) {
			return $http({
				method: 'GET',
				url: '/api/core/v4/companies/' + companyId + '/contacts/default'
			}).then(function(res){
				return res.data;
			});
		}
		function getDefaultEmployee(companyId) {
			return $http({
				method: 'GET',
				url: '/api/core/v3/companies/' + companyId + '/employees/default'
			}).then(function(res){
				return res.data;
			}).catch(function(){
				return false;
			});
		}
		function addEmployee(companyId, defaultEmployee, contactId, displayAs, staffId, fullName) {
			var primaryContact = {};
			primaryContact.id = contactId;
			primaryContact.name = displayAs;
			defaultEmployee.code = staffId;
			defaultEmployee.name = fullName;
			defaultEmployee.primaryContact = primaryContact;
			return $http({
				method: 'POST',
				url: '/api/core/v3/companies/' + companyId + '/employees',
				data: defaultEmployee,
				global: false
			}).then(function(){
				return true;
			}).catch(function(){
				return false;
			});
		}
		function getSubjectGroupId(name) {
			return $http({
				method: 'GET',
				url: '/api/profiles/v1/permissions/subject-groups'
			}).then(function(res){
				for(var i = 0; i < res.data.dtos.length; i++) {
					if (res.data.dtos[i].name === name) {
						return res.data.dtos[i].subjectGroupId;
					}
				}
			}).catch(function(){
				return false;
			});
		}
		function getStaffMemberList(subjectId) {
			var url = '/api/profiles/v1/permissions/subject-groups/members/' + subjectId;
			return $http({
				method: 'GET',
				url: url
			}).then(function(res){
				return res.data;
			}).catch(function(){
				return false;
			});
		}
		function addStaffToPermissionGroup(subjectId, permMembers, contactId) {
			var newMember = {};
			newMember.subjectGroupId = subjectId;
			newMember.subjectId = contactId;
			permMembers.members.push(newMember);
			return $http({
				method: 'PUT',
				url: '/api/profiles/v1/permissions/subject-groups/members/' + subjectId,
				data: permMembers,
				global: false
			}).then(function(){
				return true;
			}).catch(function(){
				return false;
			});
		}
		function sendRegistration(companyId, contactId, email) {
			var registrant = {};
			registrant.companyId = companyId;
			registrant.contactId = contactId;
			registrant.email = email;
			return $http({
				method: 'POST',
				url: '/api/profiles/v1/registration',
				data: registrant,
				global: false
			}).then(function(){
				return true;
			}).catch(function(){
				return false;
			});
		}
		function addContact(defaultStaff, givenName, familyName, fullName, displayAs, staffId, email, companyId) {
			defaultStaff.givenName = givenName;
			defaultStaff.familyName = familyName;
			defaultStaff.fullName = fullName;
			defaultStaff.displayAs = displayAs;
			defaultStaff.isStaffCenterEnabled = true;
			defaultStaff.employeeCode = staffId;
			defaultStaff.emailAddresses[0].emailAddress = email;
			defaultStaff.socialMedia = [];
			return $http({
				method: 'POST',
				url: '/api/core/v4/companies/' + companyId + '/contacts',
				data: defaultStaff,
				global: false
			}).then(function(res){
				return res.data;
			});
		}
		function createEmployee(companyId, contactId, displayAs, staffId, fullName) {
			return getDefaultEmployee(companyId).then(function(defaultEmployee){
				return addEmployee(companyId, defaultEmployee, contactId, displayAs, staffId, fullName);
			});
		}

		function updatePermissionGroup(selectedPermissionGroup, contactId) {
			return getSubjectGroupId(selectedPermissionGroup).then(function(subjectGroupId){
				return getStaffMemberList(subjectGroupId).then(function(permMembers){
					return addStaffToPermissionGroup(subjectGroupId, permMembers, contactId);
				});
			});
		}

		function onSendClick(givenName, familyName, fullName, displayAs, staffId, email, selectedPermissionGroup) {
			getCompanyId().then(function(companyId){
				getDefaultContact(companyId).then(function(defaultStaff) {
					addContact(defaultStaff, givenName, familyName, fullName, displayAs, staffId, email, companyId).then(function(contact){
						$q.all([
							createEmployee(companyId, contact.id, displayAs, staffId, fullName),
							updatePermissionGroup(selectedPermissionGroup, contact.id),
							sendRegistration(companyId, contact.id, email)
						]).then(function(res){
							if(res[0] && res[1] && res[2]) {
								$rootScope.$broadcast('bmShareTrialEmployeeAdded', true);
							} else {
								$rootScope.$broadcast('bmShareTrialErrorAddingStaff', res);
							}
						});
					}).catch(function(err){
						if (err.status === 400) {
							if (err.data.error.errors[0].reason === 'ClientOrStaffCenterPrimaryEmailAddressInUseError') {
								$rootScope.$broadcast('bmShareTrialErrorAddingContact', 'duplicateEmail');
							} else {
								$rootScope.$broadcast('bmShareTrialErrorAddingContact', 'unableToAddStaff');
							}
						} else {
							$rootScope.$broadcast('bmShareTrialErrorAddingContact', 'unableToAddStaff');
						}
					});
				});
			});
		}
    }
})(window.angular);
